import { ApiQueries, DaymapTypes, InterviewSlots, prettyDateRange, useAuth, useTitle } from "daymap-react";
import PageHeader from "../../containers/pageheader/pageheader"
import { PageContainer } from "../../components/layout";
import { Alert, Autocomplete, Box, Card, Skeleton, Stack, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Interviews() {
    useTitle("Parent Teacher Interviews");
    const navigate = useNavigate();
    const { groupId } = useParams();
    const { IsImpersonating } = useAuth();
    const {isPending, data} = new ApiQueries.interviews.InterviewGroup(Number(groupId)).ToQuery();
    const [student, setStudent] = useState<{ID:number, DisplaynameSurname:string} | null>(null)

    const isLocked = data?.Status == DaymapTypes.interviews.GroupStatusEnum.Locked;

    return <Box>
        <PageHeader onBackButtonClick={() => navigate(-1)} title={data?.Title} />
        <PageContainer>
            <Stack spacing={2}>
                    {isPending ? <Skeleton variant="rounded" height={150}/>
                    : <Card>
                        <Box padding={2}>
                            <Box>
                                <Typography variant="caption">Status</Typography>
                                {data?.Status == DaymapTypes.interviews.GroupStatusEnum.Booking && <Typography>Interview is open for booking</Typography>}
                                {data?.Status == DaymapTypes.interviews.GroupStatusEnum.BookingAllowTeachers && <Typography>Interview is open for booking</Typography>}
                                {isLocked && <Typography>Interview has been locked and changes cannot be made</Typography>}
                            </Box>
                            <Box>
                                <Typography variant="caption">Date Range</Typography>
                                <Typography>
                                    {prettyDateRange(data!.FirstSlotStart || data!.From, data!.LastSlotEnd || data!.To)}
                                </Typography>
                            </Box>
                            {data?.Notes && <Box>
                                <Typography variant="caption">Notes</Typography>
                                <Typography>{data?.Notes}</Typography>
                            </Box>}
                        </Box>
                    </Card>
                    }
                <StudentSelector onChange={setStudent} options={data?.ParentsStudents ?? null}/>
                {IsImpersonating && !isLocked && <Alert severity="warning" variant="outlined">Changes cannot be made while impersonating</Alert>}
                <InterviewSlots 
                    groupId={Number(groupId)} 
                    classes={data?.Constraints != 0} 
                    student={student} 
                    parentOptions={data?.ParentOptions} 
                    isLocked={IsImpersonating || isLocked} 
                    deadline={data?.BookingDeadline ?? 5}
                    maxBookings={data?.MaxBookingsPerStudent ?? 0}
                />
            </Stack>
        </PageContainer>
    </Box>
}

type StudentSelectorProps = {
    onChange: (id:{ID:number, DisplaynameSurname:string}) => void;
    options: {ID:number, DisplaynameSurname:string}[] | null
}

const StudentSelector:React.FC<StudentSelectorProps> = ({onChange, options}) => {
    const [student, setStudent] = useState<number | null>(null);

    const HandleChange = (id: number | null) => {
        if(id && options!.find(o => o.ID == id)) 
            onChange(options!.find(o => o.ID == id)!);
        setStudent(id);
    }

    useEffect(() => {
        if(!options) { return; }
        HandleChange(options[0].ID)
    },[options])

    return (
        <Autocomplete
            disablePortal
            options={options?.map(x => x.ID) ?? []}
            sx={{ width: 300 }}
            value={student}
            onChange={(_, value) => HandleChange(value)}
            renderInput={(params) => {
                const { InputProps, ...other } = params;
                const { ref, ...inputPropsWithoutRef } = InputProps;
                return <TextField {...other} InputProps={inputPropsWithoutRef} inputRef={ref} label="Student" />
            }}
            getOptionLabel={(option) =>{
               return options ? options.find(x => x.ID == option)?.DisplaynameSurname ?? "" : ""
            }
              }
        />
    )
    
}